<template>
  <router-view />
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      poll: null
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    ...mapActions(['isAuthenticated']),
    startPolling () {
      if (!this.user || this.poll) {
        return
      }
      this.poll = setInterval(async () => {
        // A tab nobody is looking at asks nothing.
        if (document.hidden) return
        if (!await this.isAuthenticated()) {
          document.location = '/'
        }
      }, 60000)
    }
  },
  watch: {
    user (user) {
      if (user) {
        this.startPolling()
      } else if (this.poll) {
        clearInterval(this.poll)
        this.poll = null
      }
    }
  },
  created () {
    this.startPolling()
  }
}
</script>
